export const getItemLS = (key: string) => localStorage.getItem(key);

export const setItemLS = (key: string, value: string) => localStorage.setItem(key, value);
